import dayjs from "dayjs";

/** 작업완료 시간 읽기 전용 표시 (yyyy-MM-dd HH:mm) */
export function formatWorkCloseDateDisplay(value) {
    if (!value) return "";
    const text = String(value).trim();
    if (!text) return "";
    const normalized = text.includes("T") ? text.replace("T", " ") : text;
    const parsed = dayjs(normalized);
    return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm") : normalized.slice(0, 16);
}

export function formatDeadLineDisplay(value) {
    if (!value) return "";
    const text = String(value).trim();
    if (!text) return "";
    const normalized = text.includes("T") ? text.replace("T", " ") : text;
    const parsed = dayjs(normalized);
    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : normalized.slice(0, 16);
}


/** WorkProcess.workTime — LocalDateTime JSON (yyyy-MM-dd'T'HH:mm:ss) */
export function normalizeWorkProcessTime(value) {
    if (!value) return undefined;
    const text = String(value).trim();
    if (!text) return undefined;

    const normalized = text.includes("T") ? text : text.replace(" ", "T");
    return normalized.slice(0, 19);
}

/**
 * @param {{ type: string, content: string, workTime?: string, operatorId?: number, deletedFileIds?: number[] }} params
 */
export function buildWorkProcess({type, content, workTime, operatorId, deletedFileIds}) {
    const dto = {
        type,
        content: content?.trim() ?? "",
        workTime: normalizeWorkProcessTime(workTime),
        operatorId: operatorId ?? undefined,
    };

    if (deletedFileIds?.length) {
        dto.deletedFileIds = deletedFileIds;
    }

    return dto;
}

/**
 * @param {{ type: string, opinion: string, pass?: boolean, newDeadline?: string }} params
 */
export function buildReview({type, opinion, pass, newDeadline}) {
    const dto = {
        type,
        opinion: opinion?.trim() ?? "",
    };

    if (pass !== undefined) {
        dto.pass = pass;
    }

    if (newDeadline) {
        dto.newDeadline = normalizeWorkProcessTime(newDeadline);
    }

    return dto;
}
